export default __webpack_public_path__ + "static/media/caret-down.389a04ef.svg";